export default __webpack_public_path__ + "static/metrics-3c06dbc333724a95d8390e5acffdf7f8.png";